if (window.location.pathname === '/sitemap/') {
  document.body.classList.add('sitemap');
}
